import React from 'react';
import {t} from 'react-switch-lang';
import './historyModal.scss';
import Modal from 'reactstrap/lib/Modal';
import TextArea from '../../../components/FormFields/Textarea';
import {useForm, FormProvider, useWatch} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import {verifyMeasure} from '../../../services/measuresService/measuresApi';
import Toast from '../../../components/toast/Toast';

function MeasuresFromShow({open, id, isOpen}) {
  const schema = yup.object().shape({
    comment: yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch} = methods;
  const toggleShowModal = (e) => {
    e && e.preventDefault();
    isOpen(!open);
  };

  const watchComment = watch('comment');
  const submitForm = async (data) => {
    const payload = {
      accepted: true,
      comment: data.comment,
    };
    try {
      const response = await verifyMeasure(id, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.verifyAccepted'),
          icon: 'success',
          timer: 3000,
        });
      }

      await window.location.reload();
    } catch (err) {
      // console.log(err, 'error');
    }
    isOpen(!open);
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    const payload = {
      accepted: false,
      comment: watchComment,
    };
    try {
      const response = await verifyMeasure(id, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.updateSuccess2', {entity: t('common.measure')}),
          icon: 'success',
          timer: 3000,
        });
      }
      await window.location.reload();
    } catch (err) {
      // console.log(err, 'error');
    }
    isOpen(!open);
  };
  return (
    <>
      <Modal isOpen={open} className="modal-sm verify-modal">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <div className="close-img">
              <img
                src="/images/exclusion.svg"
                alt="Exclusion"
                onClick={(e) => toggleShowModal(e)}
                style={{cursor: 'pointer'}}
              />
            </div>
            <div className="modal-header history-header">
              {t('mitigation-measures.verify-modal.title')}
            </div>
            <div className="modal-body verify-modal">
              <TextArea
                name="comment"
                className="form-control text-area"
                placeholder={t('placeholder.comment')}
              />
            </div>
            <div className="modal-footer history-footer">
              <button className="secondary-btn" onClick={handleCancel}>
                {t('buttons.refuse')}
              </button>
              <button className="primary-btn">{t('buttons.accept')}</button>
            </div>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
}

export default MeasuresFromShow;
